import {PerspectiveCamera, useHelper} from '@react-three/drei'
import * as THREE from 'three'
import {useFrame, extend, useThree} from '@react-three/fiber'
import {useEffect, useMemo, useRef, useState} from 'react'
import {Perf} from "r3f-perf";
import { useControls } from 'leva'
import CanvasMask from "./CanvasMask.jsx";
import Floor from "./Floor.jsx";
import Walls from "./Walls.jsx";

export default function Room({roomData, isProductOnFloor, isProductOnWall, updateWalls, _handleLoadingError}) {
    // Camera Helper
    const camera = useRef();
    //useHelper(camera, THREE.CameraHelper);
    // Directional Light Helper
    const directionalLight = useRef();
    //useHelper(directionalLight, THREE.DirectionalLightHelper);

    // viewport
    const { viewport } = useThree();

    // Controls
    const { intensity } = useControls('Light',{
        intensity:
            {
                name: 'Ambient Light',
                value: roomData.lighting.ambient.intensity,
                min: 1,
                max: 5,
                step: 0.1
            }
    })

    return <>
        {/*<Perf position="top-left" />*/}
        {/*<OrbitControls />*/}
        <PerspectiveCamera ref={camera} near={1} far={6} position={[0, 0, 6]} />

        <ambientLight intensity={intensity} />
        {
            roomData.lighting.directional != undefined &&
            <directionalLight
                ref={directionalLight}
                castShadow
                color={roomData.lighting.directional.color}
                position={roomData.lighting.directional.position}
                intensity={roomData.lighting.directional.intensity}
            />
        }

        <CanvasMask
            mask={roomData.canvas.mask}
            shadow={roomData.canvas.shadow}
            background={roomData.canvas.background}
            isProductOnFloor={isProductOnFloor}
            isProductOnWall={isProductOnWall}
            position={[0, 0, 0]}
            scale={[viewport.width, viewport.height, 1]}
        />

        {
            isProductOnWall &&
            <Walls
                model={roomData.walls.model}
                details={roomData.walls.details}
                updateWalls={updateWalls}
                _handleLoadingError={_handleLoadingError}
            />
        }

        {
            isProductOnFloor &&
            <>
                <Floor viewport={viewport} />
                {/*<Carpet rotation={ [-Math.PI/2, 0, 0] } scale={4} position={ [0, 0.3-viewport.height/2, 0] } />*/}
            </>
        }

    </>
}